import { csrfFetch } from '../../lib/helpers.js';
import Snack from '@effectivastudio/snackbar';
import IconButton from '../icon_button/element.js';
import translations from './translations.js';

import '../icon_block/element.js';

/**
 * Toggle button
 *
 * @prop active - Is active
 * @prop as - Button class
 * @prop icon - Text of the icon
 * @prop href - Link of the toggle
 * @prop remote - Data remote
 * @prop method - HTTP method
 */
export default class ToggleButton extends IconButton {
  // createRenderRoot() { return this; }

  /** @internal */
  static translations = translations;

  static properties = {
    active: { type: Boolean, reflect: true },
    translation: { type: String },
    translationSnack: { type: String },
  };

  constructor() {
    super();
    this.active = false;
    this.innerClass = 'item-with-icon';
    this.method = 'patch';
  }

  updated() {
    this.dispatchEvent(
      new Event('toggle-button:updated', { bubbles: true, composed: true })
    );
  }

  get activeKey() {
    return this.active ? 'on' : 'off';
  }

  get translatedText() {
    return (
      this.translation &&
      this.i18n.t(this.activeKey, { scope: this.translation })
    );
  }

  onClick(e) {
    e.preventDefault();

    this.updateActiveState();
    this.fetch();
  }

  toggleActive() {
    this.active = !this.active;
  }

  updateActiveState() {
    this.toggleActive();
  }

  fetch() {
    this.dispatchEvent(
      new Event('ajax:beforeSend', { bubbles: true, composed: true })
    );

    const method = this.method.toUpperCase();
    const isGETOrHead = method === 'GET' || method === 'HEAD';

    const options = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: this.method,
    };

    if (!isGETOrHead) {
      options.body = JSON.stringify({
        // Use ? as in JS tests we don't have pusher
        socket_id: window.App?.pusher?.connection?.socket_id,
      });
    }

    csrfFetch(this.href, options)
      .then(res => this.onFetchSuccess(res))
      .catch(res => this.onFetchError(res));
  }

  onFetchError() {
    this.dispatchEvent(
      new Event('ajax:error', { bubbles: true, composed: true })
    );
    this.dispatchEvent(
      new Event('ajax:complete', { bubbles: true, composed: true })
    );
    this.displaySnackBarError();
    this.updateActiveState();
  }

  onFetchSuccess() {
    this.dispatchEvent(
      new Event('ajax:success', { bubbles: true, composed: true })
    );
    this.dispatchEvent(
      new Event('ajax:complete', { bubbles: true, composed: true })
    );

    this.translationSnack &&
      Snack({
        text: this.i18n.t(this.activeKey, { scope: this.translationSnack }),
        customClass: 'snackbar-success',
      });
  }

  displaySnackBarError() {
    Snack({
      text: this.t('snack.generic_error_msg'),
      customClass: 'snackbar-danger',
    });
  }
}

ToggleButton.registerTagName('ef-toggle-button');

customElements.get('ef-toggle-button') ||
  customElements.define('ef-toggle-button', ToggleButton);
